(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-banner"] && !Shopify.designMode) return;
  try {
    
  class HotspotBanner extends HTMLElement {
    constructor() {
      super();
      this.dots = [];
      this.cards = [];
      this.activeIndex = -1;
      this.isDesktop = false;
      this.onClickOutsideBound = this.onClickOutside.bind(this);
      this.onResizeBound = this.onResize.bind(this);
      this.onMediaQueryChangeBound = this.onMediaQueryChange.bind(this);
      this.onBlockSelectBound = this.onBlockSelect.bind(this);
      this.onBlockDeselectBound = this.onBlockDeselect.bind(this);
      this.onKeyDownBound = this.onKeyDown.bind(this);
    }

    connectedCallback() {
      this.imageCtn = this.querySelector('.js-hotspotBannerImageCtn');
      this.dots = [...this.querySelectorAll('.js-hotspotDot')];
      this.cards = [...this.querySelectorAll('.js-hotspotCard')];

      this.dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          e.stopPropagation();
          const idx = parseInt(dot.dataset.index, 10);
          this.toggleHotspot(idx);
        });
      });

      this.mediaQuery = window.matchMedia('(min-width: 768px)');
      this.isDesktop = this.mediaQuery.matches;
      this.updateDotPositions();
      this.mediaQuery.addEventListener('change', this.onMediaQueryChangeBound);

      document.addEventListener('click', this.onClickOutsideBound);
      window.addEventListener('resize', this.onResizeBound);
      document.addEventListener('shopify:block:select', this.onBlockSelectBound);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselectBound);
      document.addEventListener('keydown', this.onKeyDownBound);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onClickOutsideBound);
      window.removeEventListener('resize', this.onResizeBound);
      this.mediaQuery.removeEventListener('change', this.onMediaQueryChangeBound);
      document.removeEventListener('shopify:block:select', this.onBlockSelectBound);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselectBound);
      document.removeEventListener('keydown', this.onKeyDownBound);
    }

    /**
     * Upon selecting the block in the theme editor
     */
    onBlockSelect(e) {
      if (e.detail.sectionId !== this.dataset.sectionId) return;
      const dot = this.dots.find(d => d.dataset.blockId === e.detail.blockId);
      if (dot) this.toggleHotspot(parseInt(dot.dataset.index, 10));
    }

    /**
     * Upon deselecting the block in the theme editor
     */
    onBlockDeselect(e) {
      if (e.detail.sectionId !== this.dataset.sectionId) return;
      this.closeAll();
    }

    onKeyDown(e) {
      if (e.key !== 'Escape' || this.activeIndex === -1) return;
      const idx = this.activeIndex;
      this.closeAll();
      this.dots[idx]?.focus();
    }

    onMediaQueryChange(e) {
      this.isDesktop = e.matches;
      this.updateDotPositions();
      this.closeAll();
    }

    onResize() {
      if (this.activeIndex !== -1) this.positionCard(this.activeIndex);
    }

    onClickOutside(e) {
      const inDot = this.dots.some(d => d.contains(e.target));
      const inCard = this.cards.some(c => c.contains(e.target));
      if (!inDot && !inCard) this.closeAll();
    }

    updateDotPositions() {
      this.dots.forEach(dot => {
        const x = this.isDesktop ? dot.dataset.desktopX : dot.dataset.mobileX;
        const y = this.isDesktop ? dot.dataset.desktopY : dot.dataset.mobileY;
        dot.style.left = x + '%';
        dot.style.top = y + '%';
      });
    }

    toggleHotspot(index) {
      this.closeAll();
      if (this.activeIndex === index) {
        return;
      }
      this.activeIndex = index;

      const dot = this.dots[index];
      if (dot) {
        dot.classList.add('is-active');
        dot.setAttribute('aria-expanded', 'true');
      }

      const card = this.cards.find(c => parseInt(c.dataset.index, 10) === index);
      if (card) {
        this.positionCard(index);
        card.classList.add('is-visible');
        card.setAttribute('aria-hidden', 'false');
        card.removeAttribute('tabindex');
        card.focus();
      }
    }

    closeAll() {
      this.activeIndex = -1;
      this.dots.forEach(d => {
        d.classList.remove('is-active');
        d.setAttribute('aria-expanded', 'false');
      });
      this.cards.forEach(c => {
        c.classList.remove('is-visible');
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('tabindex', '-1');
      });
    }

    /**
     * AI vide-code alert!!
     * This relatively complex logic is to make sure not only that cards
     * reposition themselves in a way to avoid the bounds of the container (easy), 
     * but also to try and avoid other dots (hard).
     */
    positionCard(index) {
      const card = this.cards.find(c => parseInt(c.dataset.index, 10) === index);
      const dot = this.dots[index];
      if (!card || !dot || !this.imageCtn) return;

      const ctnRect = this.imageCtn.getBoundingClientRect();
      const dotRect = dot.getBoundingClientRect();
      const cardH = card.offsetHeight || 80;

      if (!this.isDesktop) return;

      const cardW = card.offsetWidth || 330;
      const gap = 8;
      const dotR = dotRect.height / 2;

      const dotCX = dotRect.left + dotRect.width / 2 - ctnRect.left;
      const dotCY = dotRect.top + dotRect.height / 2 - ctnRect.top;

      const otherDots = this.dots
        .filter((_, i) => i !== index)
        .map(d => {
          const r = d.getBoundingClientRect();
          return {
            cx: r.left + r.width / 2 - ctnRect.left,
            cy: r.top + r.height / 2 - ctnRect.top,
            radius: 24
          };
        });

      const candidates = [
        { x: dotCX - dotR,                y: dotCY + dotR + gap,         preferred: true  }, // below, left-aligned with button
        { x: dotCX - dotR,                y: dotCY - cardH - dotR - gap, preferred: false }, // above, left-aligned with button
        { x: dotCX + dotR + gap,          y: dotCY - cardH / 2,          preferred: false }, // right
        { x: dotCX - cardW - dotR - gap,  y: dotCY - cardH / 2,          preferred: false }, // left
      ];

      let best = null;
      let bestScore = -Infinity;

      for (const cand of candidates) {
        let cx = Math.max(8, Math.min(cand.x, ctnRect.width - cardW - 8));
        let cy = Math.max(8, Math.min(cand.y, ctnRect.height - cardH - 8));

        let score = cand.preferred ? 0.5 : 0;
        for (const od of otherDots) {
          const overlapX = cx < od.cx + od.radius && cx + cardW > od.cx - od.radius;
          const overlapY = cy < od.cy + od.radius && cy + cardH > od.cy - od.radius;
          if (overlapX && overlapY) score -= 1;
        }

        const drift = Math.abs(cx - cand.x) + Math.abs(cy - cand.y);
        score -= drift * 0.05;

        if (score > bestScore) {
          bestScore = score;
          best = { x: cx, y: cy };
        }
      }

      if (best) {
        card.style.left = best.x + 'px';
        card.style.top = best.y + 'px';
      }
    }
  }

  customElements.define('hotspot-banner', HotspotBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrapbook-banner"] && !Shopify.designMode) return;
  try {
    
  // Singleton parallax manager with a single scroll listener
  const ParallaxManager = (() => {
    let elements = new Map(); // elm -> { baseOffset }
    let visibleElements = new Set();
    let ticking = false;
    let initialized = false;
    let observer = null;
    let mediaQuery = null;
    let resizeTimeout = null;

    function recalculateOffsets() {
      elements.forEach((data, elm) => {
        const rect = elm.getBoundingClientRect();
        data.baseOffset = rect.top + window.scrollY + rect.height / 2;
      });
    }

    function resetTransforms() {
      elements.forEach((data, elm) => {
        elm.style.transform = '';
      });
    }

    function updateParallax() {
      if (visibleElements.size === 0) return;
      if (!mediaQuery?.matches) return;

      const scrollY = window.scrollY;
      const viewportHeight = window.innerHeight;

      visibleElements.forEach((elm) => {
        const data = elements.get(elm);
        if (!data) return;

        const strength = parseFloat(elm.dataset.parallaxStrength) || 0;
        const scrollCenter = scrollY + viewportHeight / 2;
        const relativeScroll = scrollCenter - data.baseOffset;
        const translateY = relativeScroll * strength;

        elm.style.transform = `translateY(${translateY}px)`;
      });
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateParallax();
          ticking = false;
        });
        ticking = true;
      }
    }

    function onResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        recalculateOffsets();
        updateParallax();
      }, 100);
    }

    function onBreakpointChange(e) {
      if (e.matches) {
        // Entered desktop: enable resize listener and parallax
        window.addEventListener('resize', onResize, { passive: true });
        recalculateOffsets();
        updateParallax();
      } else {
        // Entered mobile: disable resize listener and reset transforms
        window.removeEventListener('resize', onResize);
        resetTransforms();
      }
    }

    function onIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          visibleElements.add(entry.target);
        } else {
          visibleElements.delete(entry.target);
        }
      });
      updateParallax();
    }

    function init() {
      if (initialized) return;

      mediaQuery = window.matchMedia('(min-width: 1024px)');
      mediaQuery.addEventListener('change', onBreakpointChange);

      // Set up resize listener if already on desktop
      if (mediaQuery.matches) {
        window.addEventListener('resize', onResize, { passive: true });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      observer = new IntersectionObserver(onIntersection, {
        rootMargin: '50% 0px'
      });
      initialized = true;
    }

    return {
      register(elm) {
        init();
        // Store the element's initial offset from the top of the document
        const rect = elm.getBoundingClientRect();
        const baseOffset = rect.top + window.scrollY + rect.height / 2;
        elements.set(elm, { baseOffset });
        observer.observe(elm);
      },
      unregister(elm) {
        elements.delete(elm);
        visibleElements.delete(elm);
        if (observer) observer.unobserve(elm);
      }
    };
  })();

  class ScrapbookBanner extends HTMLElement {
    mediaElements; // NodeList<HTMLElement>
    observer; // IntersectionObserver
    onIntersectionBound;
    prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    constructor() {
      super();
    }

    connectedCallback() {
      this.mediaElements = this.querySelectorAll('.js-scrapbookBanner__mediaInner');
      this.onIntersectionBound = this.onIntersection.bind(this);

      this.observer = new IntersectionObserver(this.onIntersectionBound, { rootMargin: '-10% 0px -20% 0px' });
      
      if (!this.prefersReducedMotion) {
        this.mediaElements.forEach(elm => {
          this.observer.observe(elm);
          ParallaxManager.register(elm);
        });
      }
    }

    disconnectedCallback() {
      this.observer.disconnect();

      if (!this.prefersReducedMotion) {
        this.mediaElements.forEach(elm => {
          ParallaxManager.unregister(elm);
        });
      }
    }

    onIntersection(elements) {
      elements.forEach((entry) => {
        if (entry.isIntersecting) {
          this.observer.unobserve(entry.target);
          entry.target.classList.add('anim');
        }
      });
    }
  }

  customElements.define('scrapbook-banner', ScrapbookBanner);

  } catch(e) { console.error(e); }
})();
})();
